export enum ScoreStatus {
    Incomplete = 'I',
    Complete = 'C',
}
